var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 0.166748C20.7001 0.166748 0.166748 20.7001 0.166748 46.0001C0.166748 71.3001 20.7001 91.8334 46.0001 91.8334C71.3001 91.8334 91.8334 71.3001 91.8334 46.0001C91.8334 20.7001 71.3001 0.166748 46.0001 0.166748ZM33.5793 65.6626L17.1251 49.2084C15.3376 47.4209 15.3376 44.5334 17.1251 42.7459C18.9126 40.9584 21.8001 40.9584 23.5876 42.7459L36.8334 55.9459L68.3667 24.4126C70.1542 22.6251 73.0418 22.6251 74.8293 24.4126C76.6168 26.2001 76.6168 29.0876 74.8293 30.8751L40.0417 65.6626C38.3001 67.4501 35.3667 67.4501 33.5793 65.6626Z",
    fill: "#009F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.2f8a69222a6d8fc1eb76fc3ae427f600.svg";
export { ForwardRef as ReactComponent };